var React = require('react');

function Logo2 (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"Layer_2","data-name":"Layer 2"},React.createElement("g",{"id":"Layer_1-2","data-name":"Layer 1"},React.createElement("path",{"d":"M39.58,4a36.49,36.49,0,0,0-2.92,4.59c-.15.26-2.39,4.42-8.62,16-2.87,5.34-5.84,10.86-6,11.18C19.7,39.94,18.42,42,14.75,42H12.81a38.9,38.9,0,0,0,2.92-4.59c.14-.25,2.13-3.94,8-14.9,3.15-5.85,6.4-11.9,6.6-12.26C32.68,6,34,4,37.6,4h2m12.8-4H37.6c-6.17,0-8.49,4.21-10.74,8.26-.38.68-14.34,26.65-14.61,27.12C9.48,40.23,7.65,43.44,0,43.44V46H14.75c6.19,0,8.52-4.2,10.77-8.26C25.9,37,39.86,11.05,40.13,10.57c2.77-4.85,4.6-8.06,12.25-8.06h0V0Z"}))));
}

Logo2.defaultProps = {"viewBox":"0 0 52.38 45.95"};

module.exports = Logo2;

Logo2.default = Logo2;
